
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"21.973"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M22 3.27a3.29 3.29 0 00-.968-2.335 3.383 3.383 0 00-4.67 0l-3.473 3.473v-.035H0v17.6h17.6V9.037l3.432-3.432A3.3 3.3 0 0022 3.27zm-2.522-.78a1.092 1.092 0 01.322.774 1.12 1.12 0 01-.322.78l-.247.246-1.554-1.554.246-.246a1.123 1.123 0 011.555 0zM11 9.413l5.122-5.116 1.554 1.554-5.116 5.122H11zm4.4 10.354H2.2v-13.2h8.536L8.8 8.503v4.664h4.664l1.936-1.936z"}})])
          )
        }
      }
    